// extracted by mini-css-extract-plugin
export var caret = "BaseSelection-module--caret--dcfd1";
export var clamp = "BaseSelection-module--clamp--85054";
export var clickable = "BaseSelection-module--clickable--71279";
export var connectDown = "BaseSelection-module--connectDown--ccdc2";
export var connectUp = "BaseSelection-module--connectUp--69e09";
export var drawer = "BaseSelection-module--drawer--ce4d1";
export var icon = "BaseSelection-module--icon--c9117";
export var iconAndDescription = "BaseSelection-module--iconAndDescription--f6440";
export var info = "BaseSelection-module--info--22232";
export var isCashedOut = "BaseSelection-module--isCashedOut--d6c45";
export var isCombo = "BaseSelection-module--isCombo--49387";
export var isEntryWon = "BaseSelection-module--isEntryWon--ed9c2";
export var isFirst = "BaseSelection-module--isFirst--493cc";
export var isLast = "BaseSelection-module--isLast--10ffc";
export var isPickem = "BaseSelection-module--isPickem--6b1c6";
export var isQuaddie = "BaseSelection-module--isQuaddie--ce2cc";
export var isSelectionWon = "BaseSelection-module--isSelectionWon--f4f72";
export var isVoid = "BaseSelection-module--isVoid--eda09";
export var marketName = "BaseSelection-module--marketName--bd417";
export var odds = "BaseSelection-module--odds--c3877";
export var outcomeName = "BaseSelection-module--outcomeName--2ae5f";
export var selection = "BaseSelection-module--selection--9db18";
export var showLineHighlight = "BaseSelection-module--showLineHighlight--ff994";